/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_landing_herotitlesuffix2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`과 함께하는 스마트 러닝`)
};

const en_landing_herotitlesuffix2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smart Learning Experience`)
};

const ja_landing_herotitlesuffix2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スマート学習体験`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const landing_herotitlesuffix2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.landing_herotitlesuffix2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("landing_herotitlesuffix2", locale)
	if (locale === "ko") return ko_landing_herotitlesuffix2(inputs)
	if (locale === "en") return en_landing_herotitlesuffix2(inputs)
	return ja_landing_herotitlesuffix2(inputs)
};
export { landing_herotitlesuffix2 as "landing_heroTitleSuffix" }